import type React from "react";
import { useTranslation } from "react-i18next";
import type { BriefDetails } from "src/model/model";

interface ButtonDetailsProps {
  data: BriefDetails | Record<string, unknown>;
  mode: "plan" | "recap";
}

const ns = "pages.chat.interactionDetails";

/** Renderer for Button, Countdown Button, Reload Button */
const ButtonDetails: React.FC<ButtonDetailsProps> = ({ data, mode }) => {
  const { t } = useTranslation();
  if (!data) return null;

  if (mode === "plan") {
    const bd = data as BriefDetails;
    if (!bd.expectedLabel && !bd.expectedNextSceneIntent && !bd.expectedCountdownSeconds)
      return null;
    return (
      <div className="space-y-1 text-[11px] text-gray-700">
        {bd.expectedLabel && (
          <div>
            <span className="font-medium text-gray-500">{t(`${ns}.label`)} : </span>
            <span className="px-1.5 py-0.5 rounded bg-blue-50 text-blue-700 border border-blue-200">
              {bd.expectedLabel}
            </span>
          </div>
        )}
        {bd.expectedCountdownSeconds && (
          <div>
            <span className="font-medium text-gray-500">{t(`${ns}.countdownSeconds`)} : </span>
            {bd.expectedCountdownSeconds}s
          </div>
        )}
        {bd.expectedNextSceneIntent && (
          <div>
            <span className="font-medium text-gray-500">{t(`${ns}.nextSceneIntent`)} : </span>
            {bd.expectedNextSceneIntent}
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default ButtonDetails;
